import block from './block';

function newsletterAdd(){
    $('.section__newsletter__form').on('submit', function (e){
        e.preventDefault();
        let newsletterForm = document.querySelector('.section__newsletter__form');
        if (newsletterForm) {
            let addedClass;
            if (window.innerWidth > 996) {
                addedClass = '.added-to';
            } else {
                addedClass = '.added-to-mobile';
            }
            let user_email = ($('.section__newsletter__form input[name="newsletter_email"]').val());
            let petsCheckboxes = newsletterForm.querySelectorAll('input[name="animals"]:checked');
            if (user_email && petsCheckboxes) {
                let animals = [];
                petsCheckboxes.forEach(function callback(e, index){
                    animals = [...animals, e.value];
                });
                let ajaxData = {
                    action: 'ajax_add_to_newsletter',
                    email: user_email,
                    animals: animals
                };

                $.post(settings.ajax_url, ajaxData)
                    .done((response) => {
                        response = JSON.parse(response);
                        if (response.output.status == "OK") {
                            $(addedClass).removeClass('d-none');
                            $(addedClass).removeClass('error-msg');
                            $(addedClass).text('Zapisałeś się do newslettera!');
                            $('.newsletter-submit').val('Dziękujemy');
                        } else if (response.output == 'No data') {
                            $(addedClass).removeClass('d-none');
                            $(addedClass).addClass('error-msg');
                            $(addedClass).text('Proszę wprowadzić odpowiednie dane');
                        }
                    }).fail(function (data, textStatus, xhr){
                    $(addedClass).removeClass('d-none');
                    $(addedClass).addClass('error-msg');
                    $(addedClass).text('Już jesteś na naszej liście mailingowej. Sprawdź pocztę');
                });
            }
        }
    });
}

export default {newsletterAdd};


// WEBPACK FOOTER //
// ./src/scripts/newsletter.js